import Game from "./components/Game/Game";
import { Main } from "./App.styled";

function App() {
  return (
    <Main>
      <Game />
    </Main>
  );
}

export default App;
